<template>
    <div>
        <app-page-top-section :title="$t('option')">
            <app-default-button
                :title="$fieldTitle('add', 'option', true)"
                v-if="$can('create_hotel_option')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="option-table"
            :options="options"
            @action="triggerActions"
        />

        <app-hotel-option-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="optionUrl"
            :hotel="tab.hotel"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('option-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import HotelOptionMixins from "../../../Mixins/HotelOptionMixins";

export default {
    name  : "HotelOption",
    mixins: [FormHelperMixins, HotelOptionMixins],
    props : {
        id: {
            type: String
        }
    },
    data() {
        return {
            tab          : this.$parent.$props.tabs.find(e => e.component === 'app-hotel-option'),
            isModalActive: false,
            optionUrl    : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.optionUrl     = `${TENANT_BASE_URL}app/hotel/option/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.optionUrl     = ''
        },
    },
}
</script>
